import './PsInit.scss';
import PhotoSwipe from 'photoswipe';
class PsInit {
    constructor( node ) {
        let images = node.querySelectorAll('[data-url][data-width][data-height]');

        let psObj;
        let options = Array(); // photoSwipe options
            options.dataSource = [];
            options.showHideAnimationType = 'zoom';

        images.forEach( function( image, index ) {

            options.dataSource.push({
                src : image.getAttribute('data-url'),
                width : image.getAttribute('data-width'),
                height : image.getAttribute('data-height'),
            });
            
        });
        images.forEach( ( btn, index ) => {
            btn.addEventListener('click', () => {
                options.index = parseInt(index, 10);
                psObj = new PhotoSwipe( options );
                psObj.init();
            });
        });

    }
    init() {}
}
JSModules['PsInit'] = PsInit;
export default PsInit;